import { useFunction, useGetWidget } from '@libs/hooks';
import { TCommonData, TMainWidgetProps, TWidget } from '@libs/types';
import React from 'react';
import type { CoreEnum } from '../types/enum';
import { getCoreWidgetById } from './widgets';

const Widget: React.FC<TMainWidgetProps> = ({ uid, widget, Package }) => {
    const { widget: finalWidget } = useGetWidget(uid ?? '', widget);

    useFunction(finalWidget ?? (widget as TWidget<TCommonData>));

    const getWidget = () => {
        const widgetById = getCoreWidgetById(finalWidget?.id as CoreEnum, finalWidget as TWidget<TCommonData>, Package);
        if (widgetById) {
            return widgetById;
        } else {
            return getCoreWidgetById(finalWidget?.alternativeId as CoreEnum, finalWidget as TWidget<TCommonData>, Package);
        }
    };

    return getWidget();
};
export default Widget;
